import { SignInButton } from '@/components/layout/signin/signin-dialog'
import { SignOutIcon } from '@/components/icons'
import {
  SidebarContent,
  SidebarContentTrigger,
  SidebarGroup,
  SidebarGroupContent,
  SidebarSeparator,
} from '@/components/ui/sidebar'
import { useAuth } from '@/services/providers/auth-provider'
import Link from 'next/link'

export function AppSidebarContent() {
  const auth = useAuth()

  return (
    <>
      <SidebarSeparator className="mx-5 h-[0.5px] bg-black" />
      <SidebarContent className="mb-8 mt-4 w-full overflow-hidden text-xl font-bold">
        <SidebarGroup className="mx-7 gap-6">
          <SidebarGroupContent className="text-base text-black">
            <Link href="/" className="cursor-pointer">
              งานแข่ง
            </Link>
          </SidebarGroupContent>
          <SidebarGroupContent className="text-base text-black">
            <Link href="/about" className="cursor-pointer">
              เกี่ยวกับ
            </Link>
          </SidebarGroupContent>
          <SidebarGroupContent className="text-base text-black">
            <Link href="/contact" className="cursor-pointer">
              ติดต่อ
            </Link>
          </SidebarGroupContent>
        </SidebarGroup>
        {auth.isAuthenticated() && (
          <SidebarSeparator className="mx-8 h-[1px] bg-black/20" />
        )}

        <SidebarGroup className="mx-7 gap-5">
          {auth.isAuthenticated() && (
            <>
              <SidebarContentTrigger contentType="profile" variant="nohover">
                <h1 className="z-50 cursor-pointer text-base font-bold text-zinc-950">
                  แก้ไขข้อมูลผู้ใช้งาน
                </h1>
              </SidebarContentTrigger>
            </>
          )}
        </SidebarGroup>

        <SidebarSeparator className="mx-5 h-[1px] bg-black/50" />

        <SidebarGroup>
          <SidebarGroupContent className="mt-2 flex justify-center">
            <SignInButton />
            {auth.isAuthenticated() && (
              <button
                onClick={() => auth.signOut()}
                className="z-50 flex h-full w-fit cursor-pointer items-center gap-2 rounded-full bg-red-500 px-4 py-2 font-line text-base text-white transition-colors hover:bg-red-600"
              >
                ออกจากระบบ
                <SignOutIcon className="h-5 w-5" />
              </button>
            )}
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </>
  )
}
